import { render, staticRenderFns } from "./market_search.vue?vue&type=template&id=22ce5fdc&scoped=true&"
import script from "./market_search.vue?vue&type=script&lang=js&"
export * from "./market_search.vue?vue&type=script&lang=js&"
import style0 from "./market_search.vue?vue&type=style&index=0&id=22ce5fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce5fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VRangeSlider})
